import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getArbCentralNavSecurity, saveCustomerOrderDetailsForTask } from '@pos-app/core-ui';
import { ArbCentralNavSecurity, CustomerDetails, CustomerSales } from '@pos-app/data';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GetAlertMessageAction } from '../../+state/customers.actions';
import { customersQuery } from '../../+state/customers.selectors';
import { NgIf, AsyncPipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';

@Component({
    selector: 'app-customer-details-view',
    templateUrl: './customer-details-view.component.html',
    styleUrls: ['./customer-details-view.component.scss'],
    imports: [NgIf, MatIcon, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, CoreUiModule, AsyncPipe, DecimalPipe, CurrencyPipe]
})
export class CustomerDetailsViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() customer: CustomerDetails;
  @Input() sales: CustomerSales;
  @Input() isExternal: boolean;
  @Input() isProgrammeUser: boolean;
  @Input() selectedCustomer: CustomerDetails;
  @Input() loadingCustomerSalesDetails$: Observable<boolean>;

  public vehicleText: string;
  public assetNumber: string;
  arbCentralSecurityFunctions$: Observable<ArbCentralNavSecurity>;

  private unSubscribe$ = new Subject<void>();

  constructor(private apiService: ApiService, private coreUiStore: Store<CoreUiPartialState>, private router: Router) {}

  ngOnInit() {
    this.arbCentralSecurityFunctions$ = this.coreUiStore.select(getArbCentralNavSecurity);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customer?.currentValue) {
      this.vehicleText = this.customer.vehicleRego
        ? `${this.customer.vehicleDescription} (${this.customer.vehicleRego})`
        : this.customer.vehicleDescription
        ? this.customer.vehicleDescription
        : '';

      if (!!changes.customer.currentValue.camperTrailerVin?.trim()) {
        this.customerTrailerSearch(this.customer.customerNumber.toString());
      }
      if (!this.customer?.customerAlertTF) {
        this.coreUiStore.dispatch(
          new GetAlertMessageAction({
            customerNumber: this.customer.customerNumber,
          })
        );
        this.coreUiStore
          .select(customersQuery.getAlertMessage)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((alertMessage) => {
            if (alertMessage && alertMessage.alertUpdatedDate !== ' ' && alertMessage.alertUpdatedTime !== 0) {
              this.customer = { ...this.customer, customerAlertTF: true };
            }
          });
      }
    }
  }

  customerTrailerSearch(customerNumber: string) {
    this.apiService
      .customerTrailerSearch({
        searchString: customerNumber,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        this.assetNumber = res.SearchResults[0].AssetNumber.toString();
      });
  }

  goToViewOrderTasks() {
    this.router.navigate([`central/task-search-customer/${this.customer.customerNumber}/${this.customer.customerName}`]);
  }
  goToAddNewTask() {
    this.coreUiStore.dispatch(saveCustomerOrderDetailsForTask({ customerOrderDetails: { ...this.customer, newTask: true } }));
    this.router.navigate([`central/task/new`]);
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
